import { useState } from 'react';
import LinearProgressBar from 'src/components/progress-bar/progressBar.component';
import { CommonHelper } from 'src/utils/commonHelper';
import { useToaster } from 'src/utils/toaster/toasterContext';
import UploadImage from '../new-post-new/uploadFile';

const ImageEditConfigurationComponent = ({ handleEditImage }) => {
  const maxFileSizeInBytes = 104857600; // 100 MB
  const SupportedFileFormat = ['image/jpeg', 'image/jpg', 'image/png'];
  const { showToast } = useToaster();

  const [fileUploadprogress, setFileUploadprogress] = useState(0);

  const handleImages = (files) => {
    const file = files[0];

    let extension = CommonHelper.GetFileExtension(file.name);

    if (SupportedFileFormat.some((a) => a.includes(extension))) {
      if (file.size > maxFileSizeInBytes) {
        showToast('Maximum file size for image is 100 MB. Please select image below 100 MB', 'e');
      } else {
        let uploadFilesProps = {
          files: [file],
          setFileUploadprogress,
          successCallback,
          failureCallback,
        };
        CommonHelper.UploadMediaFilesToServer({ ...uploadFilesProps });
      }
    } else {
      showToast('We only support JPEG, JPG, PNG file formats. The selected file are not in the supported format', 'e');
    }
  };

  const successCallback = (data, message) => {
    handleEditImage(data);
  };

  const failureCallback = (message) => {
    message && showToast(message, 'e');
  };

  return (
    <>
      <UploadImage name="images" accept={['image/*']} onDrop={handleImages} />
      {fileUploadprogress > 0 && <LinearProgressBar value={fileUploadprogress} />}
    </>
  );
};

export default ImageEditConfigurationComponent;
